




































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { objInstance } from "../store/types";
import { DrawingModule } from "../store/modules/userDrawing";

@Component({
  components: {
    formKeyValue: () => import("./formKeyValue.vue")
  }
})
export default class formLine extends Vue {
  @Prop({ type: Object, default: {} }) form!: objInstance;
  @Prop({ type: Object, default: {} }) validationRule!: objInstance;
  public listTypeLine: objInstance[] = [
    { label: "Đường nước thô", value: "Đường nước thô" },
    { label: "Truyền tải", value: "Đường trục" },
    { label: "Phân phối", value: "Phân phối" },
    { label: "Dịch vụ", value: "Dịch vụ" }
  ];

  public get infoAction() {
    return DrawingModule.infoAction;
  }

  public validateForm(): boolean {
    let isValid: boolean = false;
    (this.$refs.form as any).validate((valid: boolean) => {
      isValid = valid;
    });
    return isValid;
  }

  public resetForm(): void {
    this.$refs.form && (this.$refs.form as any).resetFields();
  }

  public removePair(idx: number) {
    this.$store.dispatch("REMOVE_PAIR_TO_NEW_INFO_DEVICE", idx);
  }
}
